module.exports = __webpack_public_path__ + "img/box_pro_four_2.22a00a3d.jpg";